import * as firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCn49_61qJ58YJVdzMo83rjvWBMWTyenng",
  authDomain: "majora-563d6.firebaseapp.com",
  databaseURL: "https://majora-563d6.firebaseio.com",
  projectId: "majora-563d6",
  storageBucket: "majora-563d6.appspot.com",
  messagingSenderId: "157653394902",
  appId: "1:157653394902:web:2ceecc38e53ce5f1973077",
};

export default !firebase.apps.length
  ? firebase.initializeApp(firebaseConfig)
  : firebase.app();
